module.exports = __webpack_public_path__ + "static/media/chat15.ce9fcfc2.svg";